import init from "../../common/base/init";
import { addEventListener } from "js-utils/src/event";

init(() => {
  const form = document.querySelector(".seminars-booking__form");
  if (!form) return;

  const message = form.querySelector(".-response");
  const modal = form.closest(".a11ydialog");

  form.addEventListener("ajax:success", (e) => {
    const response = e.detail[0];

    message.innerHTML = response.content;
    message.classList.add("-response--show");

    if (response.success) {
      const link = document.querySelector(
        `a[data-association="seminar_participants"]`
      );
      const container = document.querySelector(
        link.getAttribute(`data-association-insertion-node`)
      );
      container.innerHTML = "";
      form.reset();
    } else {
      // TODO: scroll to the `message` element
    }
  });

  form.addEventListener("submit", (e) => {
    // Enable disabled fields on submit so data won't get ignored
    const firstNestedFields = document.querySelector(
      ".seminar-booking__participants .nested-field__content"
    );
    const inputFields = firstNestedFields.querySelectorAll(".input");
    inputFields.forEach((input) => (input.disabled = false));
    return true;
  });

  modal.A11yDialogInstance.on("hide", () => {
    message.classList.remove("-response--show");
  });

  addEventListener(
    `#js--add-participant`,
    `change`,
    handleParticipantsOnChange
  );

  function handleParticipantsOnChange(e) {
    const numberOfParticipants = e.currentTarget.value;
    const link = document.querySelector(
      `a[data-association="seminar_participants"]`
    );
    if (!link) return;
    const container = document.querySelector(
      link.getAttribute(`data-association-insertion-node`)
    );
    const templateId = link.getAttribute(`data-template`);
    const template = document.querySelector(`[data-name="${templateId}"]`).innerHTML;
    const currentNumberOfParticipants = container.children.length;

    if (currentNumberOfParticipants < numberOfParticipants) {
      let i = currentNumberOfParticipants;

      for (i; i < numberOfParticipants; i++) {
        const tmp = document.createElement(`template`);
        tmp.innerHTML = template.replace(/new_seminar_participants/g, i);
        container.append(tmp.content.firstChild);
      }

      addAutocompleteCheckbox();
      return;
    }

    if (currentNumberOfParticipants >= numberOfParticipants) {
      let i = 0;
      for (i; i < currentNumberOfParticipants - numberOfParticipants; i++) {
        container.removeChild(container.lastChild);
      }

      addAutocompleteCheckbox();
      return;
    }
  }

  // Call the handler once to add the initial participant form
  handleParticipantsOnChange({ currentTarget: { value: "1" } });

  function createAutocompleteCheckbox() {
    const checkboxContainer = document.createElement("div");
    checkboxContainer.className = "checkbox checkbox-autocomplete form-row";

    const checkboxLabel = document.createElement("label");
    const checkboxLabelText = document.createTextNode(
      "Jag som beställer deltar"
    );

    const checkboxInput = document.createElement("input");
    checkboxInput.addEventListener("change", handleCheckboxOnChange);
    checkboxInput.type = "checkbox";
    checkboxInput.value = true;
    checkboxInput.id = "checkbox-autocomplete";

    checkboxLabel.appendChild(checkboxLabelText);
    checkboxLabel.appendChild(checkboxInput);
    checkboxContainer.appendChild(checkboxLabel);

    return checkboxContainer;
  }

  function handleCheckboxOnChange({ target: { checked } }) {
    const firstNestedFields = document.querySelector(
      ".seminar-booking__participants .nested-field__content"
    );
    const inputFields = firstNestedFields.querySelectorAll(".input");

    if (checked) {
      const bookingName = document.querySelector("#seminar_booking_name");
      const bookingEmail = document.querySelector("#seminar_booking_email");

      const [participantEmail, participantName] = inputFields;
      // Set current booking values on first participant on autocomplete checked
      participantEmail.value = bookingEmail.value;
      participantName.value = bookingName.value;

      // Listen to changes on main booking fields
      bookingName.addEventListener("input", ({ target: { value } }) => {
        const { checked } = document.querySelector("#checkbox-autocomplete");
        if (checked) participantName.value = value;
      });

      bookingEmail.addEventListener("input", ({ target: { value } }) => {
        const { checked } = document.querySelector("#checkbox-autocomplete");
        if (checked) participantEmail.value = value;
      });

      // Disable fields when autocomplete is checked
      inputFields.forEach((input) => (input.disabled = true));
    } else {
      // Clean fields on autocomplete uncheck
      inputFields.forEach((input) => {
        input.value = "";
        input.disabled = false;
      });
    }
  }

  function addAutocompleteCheckbox() {
    const firstNestedFields = document.querySelector(
      ".seminar-booking__participants .nested-field__content"
    );

    const checkboxElement = document.querySelector(".checkbox-autocomplete");
    if (checkboxElement) {
      checkboxElement.parentNode.removeChild(checkboxElement);
      firstNestedFields.prepend(checkboxElement);
      return;
    }

    const newCheckboxElement = createAutocompleteCheckbox();
    firstNestedFields.prepend(newCheckboxElement);
  }
});
